import { ProtectedRoute } from "@excent-one/auth";
import AppNavigationItemsProvider from "@phrmpc/app/providers/AppNavigationItemsProvider";

const NavigationLayout = () => (
  <AppNavigationItemsProvider>
    <ProtectedRoute forbiddenPageUrl="/error/forbidden" />
  </AppNavigationItemsProvider>
);

export default NavigationLayout;
